/**
* 欢迎来到墨子工程
* 邮箱: duheng1100@163.com
* github: https://github.com/duheng/
**/
'use strict';

var index = require('./index-9e1f1547.js');
var themeContent = require('./themeContent-f8df7540.js');
var normalizeComponent = require('./normalize-component-d885d5ff.js');

//
var script = {
  name: "ThemeSelect",
  data: function data() {
    return {
      visible: false,
      list: []
    };
  },
  components: {
    LayPopup: index.__vue_component__,
    ThemeContent: themeContent.__vue_component__
  },
  mounted: function mounted() {
    var _this = this;
    this.$eventBus.$on('showTheme', function (val) {
      _this.open();
    });
  },
  watch: {
    $mq: {
      handler: function handler(val) {
        if (val == 'pd' || val == 'ph') {
          this.close();
        }
      }
    }
  },
  methods: {
    open: function open() {
      this.$refs.layPopupTheme.open();
    },
    close: function close() {
      this.$refs.layPopupTheme.close();
    }
  }
};

/* script */
const __vue_script__ = script;
/* template */
var __vue_render__ = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    [
      _c(
        "lay-popup",
        {
          ref: "layPopupTheme",
          staticClass: "width400",
          attrs: {
            closeBtn: false,
            isphone: _vm.$mq == "ph",
            drawerRadius: false,
            maskClose: true,
            modal: false,
            size: "100%",
          },
        },
        [_c("ThemeContent")],
        1
      ),
    ],
    1
  )
};
var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = "data-v-5f8b2e55";
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/normalizeComponent.normalizeComponent(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

exports.__vue_component__ = __vue_component__;
